import { useEffect, useState } from 'react'
import { getCable } from '@/lib/cable'
import type { ExploreAudience } from '@/types/explore'

const NOBODY: ExploreAudience = {}

function isAudience(message: unknown): message is { data: ExploreAudience } {
  return typeof message === 'object' && message !== null && (message as { type?: unknown }).type === 'audience.updated'
}

/**
 * Who is watching each host on /explore, over the app's one socket (docs/REALTIME.md). `ExploreChannel` sends the whole
 * of it on every subscribe and when it changes, so a dropped socket catches up by itself. Nothing until the first
 * message, and nothing when LiveKit can't say: the cards then show no audience rather than an empty room.
 */
export function useExploreAudience(): ExploreAudience {
  const [audience, setAudience] = useState(NOBODY)
  useEffect(
    () =>
      getCable().subscribe({ channel: 'ExploreChannel' }, (message: unknown) => {
        if (isAudience(message)) setAudience(message.data)
      }),
    [],
  )
  return audience
}
